import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { signInWithGoogle, auth } from '../lib/firebase';
import { signOut } from 'firebase/auth';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { user, loading } = useAuth();

  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error: any) {
      console.error('Sign-in error:', error);
      
      // Log specific error details
      if (error.code) {
        console.error('Error code:', error.code);
        console.error('Error message:', error.message);
        
        // Handle specific Firebase Auth errors
        switch (error.code) {
          case 'auth/popup-closed-by-user':
            console.log('Sign-in popup closed by user');
            break;
          case 'auth/unauthorized-domain':
            alert('This domain is not authorized for OAuth operations. Please contact your administrator.');
            break;
          case 'auth/operation-not-allowed':
            alert('Google sign-in is not enabled. Please contact your administrator.');
            break;
          case 'auth/popup-blocked':
            alert('Sign-in popup was blocked. Please allow popups for this site.');
            break;
          default:
            alert(`Failed to sign in: ${error.message}`);
        }
      } else {
        alert('Failed to sign in. Please check the console for details.');
      }
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Sign-out error:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1>GD Shortcuts Manager</h1>
          <p>Manage your medical text expansion shortcuts</p>
          <button className="google-signin-btn" onClick={handleSignIn}>
            <svg className="google-icon" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </button>
          <p className="domain-notice">Only @gangerdermatology.com accounts allowed</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>GD Shortcuts Manager</h1>
        <div className="user-info">
          <span>{user.email}</span>
          <button className="sign-out-btn" onClick={handleSignOut}>Sign Out</button>
        </div>
      </header>
      <main className="app-main">{children}</main>
    </div>
  );
}